export default __webpack_public_path__ + "static/media/_DSC0447.d7ed1450.JPG";